<template>
  <div id="app" :class="iphoneNotch ? 'have-notch_' : ''">
    <ion-app>
      <ion-menu side="start" content-id="main-content">
        <ion-header>
          <ion-toolbar>
            <ion-buttons slot="start">
              <ion-menu-button auto-hide="false">
                <ion-icon name="arrow-back"></ion-icon>
              </ion-menu-button>
            </ion-buttons>
            <ion-title>Menù</ion-title>
          </ion-toolbar>
        </ion-header>
        <ion-content>
          <ion-list>
            <ion-item button @click="() => goTo('home')">Home</ion-item>
            <ion-item button @click="() => goTo('profile')">Profile</ion-item>
            <ion-item button @click="() => goTo('yacht-list')">Yachts list</ion-item>
            <ion-item button @click="() => goTo('templates')" v-if="$store.state.user_role != 'client'">Index templates</ion-item>
            <ion-item v-if="$store.state.user_role != 'user' && $store.state.user_role != 'client'" button @click="() => goTo('files')">Files</ion-item>
            <ion-item button @click="() => goTo('login')">Logout</ion-item>
          </ion-list>
          <!-- <img class="menu-img" src="./assets/logo-menu.jpg"> -->
        </ion-content>
      </ion-menu>
      <div id="main-content">
        <router-view />
      </div>
    </ion-app>
  </div>
</template>

<script>
import Browserizr from 'browserizr'
export default {
  name: "App",
  data: function() {
    return {
      iphoneNotch: Browserizr.detect().isIOS() && !Browserizr.detect().isIPhone678() && !Browserizr.detect().isIPhone678plus() && !Browserizr.detect().isIPhone5() && !Browserizr.detect().isIPhone4()
    }
  },
  methods: {
    goTo(page) {
      document.querySelector('ion-menu').close()

      if(this.$router.history.current.name != page) {
        this.$router.push('/'+page);
      }
    },
  },
  updated: function(){
    if(!this.$store.state.api_token) {
      this.goTo('login')
    }
  }
};
</script>

<style>
@font-face {
  font-family: 'dinregularalternate';
  src: url('./assets/fonts/din/din_regularalternate-webfont.woff2') format('woff2'),
       url('./assets/fonts/din/din_regularalternate-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'dinlight';
  src: url('./assets/fonts/din/din_light_regular-webfont.woff2') format('woff2'),
       url('./assets/fonts/din/din_light_regular-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'dinmedium';
  src: url('./assets/fonts/din/din_medium-webfont.woff2') format('woff2'),
       url('./assets/fonts/din/din_medium-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'myriadproregular';
  src: url('./assets/fonts/myriad-pro/MYRIADPRO-REGULAR.woff') format('woff');
  font-style: normal;
  font-weight: normal;
}

/*
@font-face {
font-family: 'Myriad Pro Condensed';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Condensed'), url('MYRIADPRO-COND.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Condensed Italic';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Condensed Italic'), url('MYRIADPRO-CONDIT.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Light';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Light'), url('MyriadPro-Light.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Semibold';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Semibold'), url('MYRIADPRO-SEMIBOLD.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Semibold Italic';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Semibold Italic'), url('MYRIADPRO-SEMIBOLDIT.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Bold Condensed';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Bold Condensed'), url('MYRIADPRO-BOLDCOND.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Bold';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Bold'), url('MYRIADPRO-BOLD.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Bold Italic';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Bold Italic'), url('MYRIADPRO-BOLDIT.woff') format('woff');
}


@font-face {
font-family: 'Myriad Pro Bold Condensed Italic';
font-style: normal;
font-weight: normal;
src: local('Myriad Pro Bold Condensed Italic'), url('MYRIADPRO-BOLDCONDIT.woff') format('woff');
}
*/


#app {
  font-family: "dinmedium", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.menu-img {
  width: 80px;
  height: auto;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

:root {
  --ion-toolbar-background: #63656A;
  --ion-toolbar-color: #ffffff;
  --ion-color-primary: #EC3B3E;
  --ion-color-primary-rgb: rgb(237, 68, 65);
  --ion-color-primary-contrast: #e5bebe;
  --ion-color-primary-contrast-rgb: rgb(229, 190, 190);
  --ion-color-primary-shade: #ff2225;
  --ion-color-primary-tint: #ff2225;
  --ion-color-secondary: #515256;
  --ion-color-secondary-rgb: rgb(81, 82, 86);
  --ion-color-secondary-contrast: #b5b5b5;
  --ion-color-secondary-contrast-rgb: rgb(181, 181, 181);
  --ion-color-secondary-shade: #404144;
  --ion-color-secondary-tint: #404144;
}

ion-button {
  --color: #fff;
  --background: var(--ion-color-primary);
  --background-activated: var(--ion-color-primary-shade);
  --background-hover: var(--ion-color-primary-shade);
  --box-shadow: none;
  --border-radius: 5px;
  font-family: "dinmedium";
  letter-spacing: 0;
  cursor: pointer;
}

ion-menu-button {
  --color: #fff !important;
  --color-focused	: #fff !important;
  --color-hover	: #fff !important;
}

ion-header ion-icon {
  color: #fff !important;
}

.btn-left {
  margin-right: auto;
}

.ios ion-header ion-toolbar:first-child {
  padding-top: 10px !important;
}

.have-notch ion-header ion-toolbar:first-child {
  padding-top: 40px !important;
}

#main-content {
  width: 100%;
  height: 100%;
}

input[type="text"],
input[type="email"],
input[type="password"] {
  padding: 0 15px;
  height: 50px;
  line-height: 50px;
  width: 100%;
  font-size: 18px;
  color: #63656A!important;
  margin-bottom: 20px;
  border: none;
  outline: none;
  border-radius: 5px;
  background-color: #D1D3D4!important;
  font-family: "dinmedium";
}

::placeholder {
  color: #63656A;
  opacity: 1;
}

:-ms-input-placeholder {
  color: #63656A;
}

::-ms-input-placeholder {
  color: #63656A;
}

ion-toolbar {
  --min-height: 100px;
  border-bottom: 10px solid var(--ion-color-primary);
}

ion-header::after {
  display: none!important;
}

.btn-image-toolbar img,
ion-menu-toggle img {
  width: 65px;
  height: auto;
  margin-left: 25px;
}

ion-button.btn-squared {
  width: 200px;
  height: 200px;
  --background: #D1D3D4!important;
  --background-hover: #D1D3D4!important;
  --background-activated: #D1D3D4!important;
  --background-focused: #D1D3D4!important;
  --ripple-color: #D1D3D4;
  position: relative;
  --border-radius: 0;
  border: 5px solid #D1D3D4;
  border-radius: 5px;
}

ion-button.btn-squared-disabled {
  --background: var(--ion-color-primary)!important;
  --background-hover: var(--ion-color-primary)!important;
  --background-activated: var(--ion-color-primary)!important;
  --background-focused: var(--ion-color-primary)!important;
  border: 5px solid var(--ion-color-primary);
}

.btn-squared-wrapper {
  margin: 20px;
  display: inline-block;
  vertical-align: top;
}

.btn-squared-label {
  text-transform: uppercase;
  color: #63656A;
  font-size: 18px;
  font-family: "dinmedium";
  margin-top: 5px;
}

.btn-squared-link{
  text-decoration: underline;
  margin-top: 5px;
  cursor: pointer;
}

ion-button.btn-squared::after {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background-image: url(./assets/svg/btn-hover.svg);
  position: absolute;
  bottom: 0;
  left: 0;
}

ion-input {
  text-align: left;
  --padding-start: 15px!important;
  --padding-end: 15px!important;
  --border-radius: 5px;
}

.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.row-boxed {
  max-width: 900px;
  padding: 0 20px;
  margin: 0 auto;
}

ion-col {
  padding: 5px 10px 5px 10px;
}

.native-input[disabled] {
  opacity: .8!important;
  cursor: not-allowed;
}

.hidden {
  display: none;
}

ion-button.btn-back {
  border-radius: 5px;
  border: 1px solid #fff;
  --padding-start: 20px;
  --padding-end: 20px;
  --padding-top: 10px;
  --padding-bottom: 10px;
  margin-right: 25px;
}

#yacht_name {
  padding-left: 10px;
  padding-right: 10px;
}

.pr-25 {
  padding-right: 25px!important;
}

.mt-10 {
  margin-top: 10px!important;
}

.mt-20 {
  margin-top: 40px!important;
}

.mb-20 {
  margin-bottom: 20px!important;
}

.mb-10 {
  margin-bottom: 10px!important;
}

.pl-40 {
  padding-left: 40px;
}

.pl-50 {
  padding-left: 50px;
}

.text-lower {
  text-transform: none;
}

ion-button.btn-icon {
  height: 35px;
  margin: 0;
  --padding-start: 0;
  --padding-end: 0;
  --background: transparent;
  --background-activated: transparent;
  --background-hover: transparent;
  --background-focused: transparent;
  --border-radius: 0;
  --ripple-color: #fff;
}

ion-button.btn-icon img {
  width: 35px;
  height: 35px;
}

.row-index {
  display: flex;
  align-items: center;
  position: relative;
  margin: 0 -10px 20px;
}

.row-index-child {
  /* transform: translateX(50px); */
}

.row-index input {
  margin-bottom: 0;
}

.col-index {
  padding: 0 8px;
}

.col-index-10 {
  width: 10%;
}

.col-index-15 {
  width: 15%;
}

.col-index-3 {
  width: 40%;
}

.col-index-20 {
  width: 20%;
}

.col-index-25 {
  width: 25%;
}

.col-index-30 {
  width: 30%;
}

.col-index-60 {
  width: 60%;
}

.fix-pl-50 {
  margin-left: -50px;
}

select {
  position: relative;
  z-index: 1;
  height: 50px;
  border-radius: 5px;
  padding: 10px 15px;
  border: none;
  background-color: #D1D3D4!important;
  outline: none;
  color: #63656A!important;
  width: 100%;
}

.btn-absolute {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5px;
}

.btn-link {
  display: block;
  text-align: left;
  color: #63656A!important;
  font-size: 16px;
  cursor: pointer;
  transition: .4s all;
}

.btn-link:hover {
  opacity: .8;
}

.title {
  text-align: left;
  font-size: 24px;
  text-transform: uppercase;
  max-width: 900px;
  margin: 0 auto;
  font-family: "dinlight", Helvetica, Arial, sans-serif;
}

.select2-container {
  margin-bottom: 20px;
  width: 100%!important;
}

.select2-container--default .select2-selection--multiple {
  height: 50px;
}

.select2-container .select2-search--inline .select2-search__field {
  margin: 0!important;
}

.select2-container--default .select2-search--inline .select2-search__field {
  height: 50px;
  line-height: 50px;
  width: 100%!important;
  padding: 10px 10px!important;
}

.select2-selection.select2-selection--multiple {
  border: none!important;
  border-radius: 4px;
}

.select2-selection__rendered {
  color: #63656A!important;
  background-color: #D1D3D4!important;
  border-radius: 4px;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #D1D3D4!important;
  color: #63656A!important;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
  color: #D1D3D4!important;
  background-color: #63656A!important;
}

.select2-dropdown {
  border-color: #D1D3D4!important;
}

.upload-btn {
  background-color: #D1D3D4!important;
  color: #63656A!important;
  display: block;
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-radius: 4px;
  padding: 0 15px;
  text-align: left!important;
}

.upload-btn label {
  cursor: pointer;
}

.row-report {
  text-align: left;
  width: 100%;
}

.row-report > div {
  position: relative;
  padding: 0 15px;
  border-radius: 4px;
  height: 50px;
  line-height: 50px;
  color: #63656A;
  background-color: #D1D3D4;
  cursor: pointer;
}

.row-report span {
  margin-right: 40px;
}

.row-report-indent {
  padding-left: 50px;
}

.row-report .light {
  position: absolute;
  top: 10px;
  left: -50px;
}

.nowrap {
  white-space: nowrap;
}

.light-wrapper {
  white-space: nowrap;
  width: 100%;
}

.light-wrapper .light {
  display: inline-block;
  margin: 0 4px;
}

.light {
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 4px;
}

.light.is-active::before {
  content: '';
  display: block;
  width: 8px;
  height: 17px;
  border-bottom: 3px solid #63656A;
  border-right: 3px solid #63656A;
  position: absolute;
  transform: rotate(45deg);
  top: 2px;
  left: 9px;
}

.light.red {
  background-color: #ED1C24;
}

.light.green {
  background-color: #00A650;
}

.light.yellow {
  background-color: #FFF200;
}

.light.dark {
  background-color: #63656A;
}

.light.nocolor {
  background-color: #D1D3D4;
}

ion-grid {
  position: relative;
  z-index: 10;
}

.tox-tinymce {
  width: 100%;
}

.tox-statusbar__path,
.tox-statusbar__branding {
  display: none!important;
}

.toolbar-add {
  background-color: #63656A;
  color: #fff;
  text-align: left;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  text-transform: uppercase;
  display: flex;
  align-items: center;
}

.toolbar-add img {
  height: 25px;
  margin-right: 15px;
}

.item-block {
  border: 1px solid #63656A;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 15px;
}

.item-block-header img {
  height: 30px;
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;
}

.item-block-header-note > span {
  position: absolute;
  right: 0;
  top: 10px;
  background-color: transparent!important;
  overflow: hidden;
  height: 30px;
}

.item-block-header-note img {
  position: static;
}

.item-block-header {
  background-color: #D1D3D4;
  display: flex;
  position: relative;
}

.item-block-content > div,
.item-block-header > div {
  padding: 15px;
  text-align: left;
}

.item-block-content .first,
.item-block-header .first {
  width: 58%;
  border-right: 1px solid #D1D3D4;
}

.item-block-content .second,
.item-block-header .second {
  text-align: center;
  width: 19%;
  border-right: 1px solid #D1D3D4;
}

.item-block-content .third,
.item-block-header .third {
  width: 23%;
}

.item-block-header .third {
  text-align: center;
}

.item-block-content {
  display: flex;
  border-bottom: 1px solid #D1D3D4;
}

.m-neg .item-block-content {
  height: 231px;
  overflow: auto;
}

.row-notes .item-block-content {
  height: 120px;
  overflow: auto;
}

.item-block-content-full {
  padding: 15px;
  text-align: left;
}

.item-block-content .first span,
.item-block-content .third span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; 
}

.item-block-btns {
  padding: 5px 15px;
  text-align: right;
}

.modal-wrapper {
  width: 100%!important;
  height: 100%!important;
  max-width: none!important;
}

.item-textarea {
  width: 100%;
  height: 200px;
  resize: vertical;
  border: none;
  outline: none;
}

.item-textarea-small {
  height: 80px;
}

.m-neg {
  margin: 0 -10px;
}

.img-wrapper {
  width: 100%;
  display: block;
}

table th,
table td {
  padding: 5px;
}

.align-top {
  display: flex;
  justify-content: flex-end;
}

.pointer,
.pointer label {
  cursor: pointer;
}

.prev {
  width: 30px;
  height: 30px;
  position: relative;
}

.prev::before {
  content: '';
  display: block;
  width: 15px;
  height: 15px;
  border-top: 1px solid;
  border-left: 1px solid;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%) rotate(45deg);
  margin-top: 4px;
}

.next {
  width: 30px;
  height: 30px;
  position: relative;
}

.next::before {
  content: '';
  display: block;
  width: 15px;
  height: 15px;
  border-bottom: 1px solid;
  border-right: 1px solid;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%) rotate(45deg);
  margin-top: -4px;
}

.fix-padded {
  margin-left: -20px;
}

.progress-wrapper {
  width: 100%;
  margin-top: 20px;
  padding-left: 100px;
  position: relative;
}

.progress-wrapper > span {
  display: block;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  text-transform: uppercase;
}

.vue-range-slider.slider-component .slider .slider-process {
  background-color: #ED1C24 !important;
}

.vue-range-slider.slider-component .slider .slider-tooltip {
  background-color: #ED1C24 !important;
  border-color: #ED1C24 !important;
}

@media screen and (max-width:767px) {
  .row-index {
    flex-wrap: wrap;
    padding-left: 45px;
  }

  .btn-absolute {
    top: 20px;
    left: 0!important;
  }

  .btn-absolute-top {
    top: 70px;
    left: 0!important;
  }

  .btn-absolute-bottom {
    top: 120px;
    left: 0!important;
  }

  .col-index-3,
  .col-index-30,
  .col-index-20,
  .col-index-15,
  .col-index-60 {
    width: 100%;
    margin-bottom: 5px;
  }

  .overflow-scroll-mobile {
    overflow: scroll;
    text-overflow: ellipsis;
  }

  .row-report > div {
    white-space: nowrap;
  }

  .item-block-content,
  .item-block-header {
    white-space: nowrap;
    /* display: block; */
    flex-wrap: nowrap;
  }

  /* .item-block-header::after {
    content: '';
    display: table;
    clear: both;
  } */

  .item-block-content > *,
  .item-block-header > * {
    /* float: left; */
  }

  .item-block-content .first,
  .item-block-header .first {
    width: 60%;
  }

  .item-block-content .second,
  .item-block-header .second {
    width: 40%;
  }

  .item-block-content .first span {
    text-overflow: ellipsis;
  }

  .item-block-content .second .dark {
    display: none;
  }

  .item-block-content .third,
  .item-block-header .third {
    display: none;
  }
}
</style>